import { render } from "./SuccessDialogV2.vue?vue&type=template&id=73768faa&scoped=true"
import script from "./SuccessDialogV2.vue?vue&type=script&lang=js"
export * from "./SuccessDialogV2.vue?vue&type=script&lang=js"

import "./SuccessDialogV2.vue?vue&type=style&index=0&id=73768faa&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73768faa"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpinnerDots,QCardActions,QBtn,QCheckbox});qInstall(script, 'directives', {ClosePopup});
